<template>
  <div class="col-md-6">
    <card>
      <h4 class="card-title">Status</h4>
      <hr>
        <nav>
            <ul>
                <li><a href="#">Status1</a></li>
                <li><a href="#">Status2</a></li>
                <li><a href="#">Status3</a></li>
                <li><a href="#">Status4</a></li>
                <li><a href="#">Status5</a></li>
                <li><a href="#">Status6</a></li>
            </ul>
        </nav>
    </card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "filterStatus"
    };
  }
};
</script>

<style>
</style>